/*
 * Looping product video (one section for desktop, one for mobile; only the one on show loads a video).
 * Plays only while on screen (IntersectionObserver) to save battery and data, and resumes when it scrolls back in.
 * With reduced motion, or if the video cannot load, the poster image is shown instead.
 */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 750px)');

  [].slice.call(document.querySelectorAll('[data-ex-video]')).forEach(function (root) {
    var v = root.querySelector('video');
    if (!v) return;
    var mine = root.getAttribute('data-device') === 'desktop';   // the screen size this section is for
    var src = v.getAttribute('data-src');
    var inView = false;

    function fallback() {
      root.setAttribute('data-fallback', '1');
      try { v.pause(); } catch (e) {}
      v.removeAttribute('src');
      try { v.load(); } catch (e) {}
    }

    function active() { return wide.matches === mine && !root.hasAttribute('data-fallback'); }

    function sync() {
      if (!active()) {
        try { v.pause(); } catch (e) {}
        if (v.getAttribute('src')) { v.removeAttribute('src'); try { v.load(); } catch (e) {} }   // other screen size: no download
        return;
      }
      if (!v.getAttribute('src') && src) v.setAttribute('src', src);
      if (inView && !document.hidden) {
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* autoplay blocked: the poster stays visible */ });
      } else {
        try { v.pause(); } catch (e) {}
      }
    }

    if (reduced.matches || !src) { fallback(); return; }

    v.muted = true;
    v.defaultMuted = true;
    v.addEventListener('error', function () { if (v.getAttribute('src')) fallback(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[entries.length - 1].isIntersecting;
        sync();
      }, { threshold: 0.25 }).observe(root);
    } else {
      inView = true;
    }
    document.addEventListener('visibilitychange', sync);
    if (wide.addEventListener) wide.addEventListener('change', sync);
    if (reduced.addEventListener) reduced.addEventListener('change', function (e) { if (e.matches) fallback(); });
    sync();
  });
})();
